import React from "react";
import { Col, Container } from "react-bootstrap";
import { Icon, Loading } from "ui";
import { status } from "utils/status";
import { useTerminals } from "../api/get-terminals";
import styles from "./terminals.module.scss";
import moment from "moment-jalaali";
export const Terminals = () => {
  const { data, error, isFetching } = useTerminals({
    PageNumber: 1,
    PageSize: 20,
  });

  return (
    <Container>
      <div className={styles.terminals_container}>
        {!!error && (
          <span className="text-danger w-100 flex-center">
            {error?.message}
          </span>
        )}
        {isFetching && <Loading />}
        {data?.data?.map((item, index) => {
          return (
            <Col key={index} md={4} sm={4} className={styles.terminal}>
              <div>
                <div>
                  <strong>شماره درگاه : </strong>
                  <label>{item?.terminalNumber || "نامشخص"}</label>
                </div>
                <div>
                  <strong>تاریخ ایجاد : </strong>
                  <label>
                    {moment(item.setupDateValue).format("jYYYY/jMM/jDD") ||
                      "نامشخص"}
                  </label>
                </div>
              </div>
              <Icon type="terminals" className={styles.icon} />
            </Col>
          );
        })}
      </div>
    </Container>
  );
};
